import { DataEnumerations } from '../types';

export const regionsOptions: DataEnumerations = [
    { value: 'praha', title: 'Hlavní město Praha' },
    { value: 'jihocesky', title: 'Jihočeský kraj' },
    { value: 'jihomoravsky', title: 'Jihomoravský kraj' },
    { value: 'karlovarsky', title: 'Karlovarský kraj' },
    { value: 'kralovehradecky', title: 'Královehradecký kraj' },
    { value: 'liberecky', title: 'Liberecký kraj' },
    { value: 'moravskoslezsky', title: 'Moravskoslezský kraj' },
    { value: 'olomoucky', title: 'Olomoucký kraj' },
    { value: 'pardubicky', title: 'Pardubický kraj' },
    { value: 'plzensky', title: 'Plzeňský kraj' },
    { value: 'stredocesky', title: 'Středočeský kraj' },
    { value: 'ustecky', title: 'Ústecký kraj' },
    { value: 'vysocina', title: 'Vysočina' },
    { value: 'zlinsky', title: 'Zlínský kraj' },
];

export const buildingPhaseOptions: DataEnumerations = [
    { value: 'thinking', title: 'Uvažuji o stavbě' },
    { value: 'building', title: 'Stavím' },
    { value: 'finished', title: 'Mám postaveno' },
];

export const buildDateOptions: DataEnumerations = [
    { value: 'BEFORE_1960', title: 'před 1960' },
    { value: 'BETWEEN_1960_AND_1970', title: '1960 - 1969' },
    { value: 'BETWEEN_1970_AND_1980', title: '1970 - 1979' },
    { value: 'BETWEEN_1980_AND_1990', title: '1980 - 1989' },
    { value: 'BETWEEN_1990_AND_2000', title: '1990 - 1999' },
    { value: 'BETWEEN_2000_AND_2010', title: '2000 - 2009' },
    { value: 'BETWEEN_2010_AND_2020', title: '2010 - 2019' },
    { value: 'AFTER_2020', title: '2020+' },
];

export const booleanOptions: DataEnumerations = [
    { value: 'true', title: 'Ano' },
    { value: 'false', title: 'Ne' },
];

export const typeOfPENBOptions: DataEnumerations = [
    {
        value: 'BEFORE_1_9_2020',
        title: 'PENB podle vyhlášky 78/2013',
        description: 'Do 1.9.2020',
        img: '/img/otz/typ-penb/vyhlaska-1.png',
        imgTc: '/img/otz/typ-penb/vyhlaska-1-tc.png',
    },
    {
        value: 'AFTER_1_9_2020',
        title: 'PENB podle vyhlášky 264/2020',
        description: 'Od 1.9.2020',
        img: '/img/otz/typ-penb/vyhlaska-2.png',
        imgTc: '/img/otz/typ-penb/vyhlaska-2-tc.png',
    },
];

export const roofTypesOptions: DataEnumerations = [
    {
        value: 'GABLE',
        title: 'Sedlová střecha',
        img: '/img/otz/typ-strechy/sedlova-strecha.png',
    },
    {
        value: 'FLAT',
        title: 'Plochá střecha',
        img: '/img/otz/typ-strechy/plocha-strecha.png',
    },
    {
        value: 'COUNTER',
        title: 'Pultová střecha',
        img: '/img/otz/typ-strechy/pultova-strecha.png',
    },
    {
        value: 'HIPPED',
        title: 'Stanová/Valbová',
        img: '/img/otz/typ-strechy/stanova-valbova-strecha.png',
    },
];

export const houseFloorPlaneShapeOptions: DataEnumerations = [
    {
        value: 'RECTANGULAR',
        title: '"Čtverec/obdelník"',
        img: '/img/otz/pudorys/ctverec-obdelnik/default.svg',
    },
    {
        value: 'U_SHAPE',
        title: '"Účko"',
        img: '/img/otz/pudorys/ucko/default.svg',
    },
    {
        value: 'L_SHAPE',
        title: '"Elko"',
        img: '/img/otz/pudorys/elko/default.svg',
    },
    {
        value: 'T_SHAPE',
        title: '"Téčko"',
        img: '/img/otz/pudorys/tecko/default.svg',
    },
];

export const houseFloorPlaneRectangularShapeOptions: DataEnumerations = [
    {
        value: 'RECTANGULAR_1_TO_1',
        title: '"Čtverec/obdelník č.1"',
        img: '/img/otz/pudorys/ctverec-obdelnik/variant-1.svg',
    },
    {
        value: 'RECTANGULAR_1_TO_2',
        title: '"Čtverec/obdelník č.2"',
        img: '/img/otz/pudorys/ctverec-obdelnik/variant-2.svg',
    },
    {
        value: 'RECTANGULAR_1_TO_3',
        title: '"Čtverec/obdelník č.3"',
        img: '/img/otz/pudorys/ctverec-obdelnik/variant-3.svg',
    },
];

export const houseFloorPlaneLShapeOptions: DataEnumerations = [
    {
        value: 'L_SHAPED_1_TO_1',
        title: '"Elko č.1"',
        img: '/img/otz/pudorys/elko/variant-1.svg',
    },
    {
        value: 'L_SHAPED_1_TO_2',
        title: '"Elko č.2"',
        img: '/img/otz/pudorys/elko/variant-2.svg',
    },
    {
        value: 'L_SHAPED_1_TO_3',
        title: '"Elko č.3"',
        img: '/img/otz/pudorys/elko/variant-3.svg',
    },
];

export const houseFloorPlaneUShapeOptions: DataEnumerations = [
    {
        value: 'U_SHAPED_1_TO_1',
        title: '"Účko č.1"',
        img: '/img/otz/pudorys/ucko/variant-1.svg',
    },
    {
        value: 'U_SHAPED_1_TO_2',
        title: '"Účko č.2"',
        img: '/img/otz/pudorys/ucko/variant-2.svg',
    },
    {
        value: 'U_SHAPED_1_TO_3',
        title: '"Účko č.3"',
        img: '/img/otz/pudorys/ucko/variant-3.svg',
    },
];

export const houseFloorPlaneTShapeOptions: DataEnumerations = [
    {
        value: 'T_SHAPED_1_TO_1',
        title: '"Téčko č.1"',
        img: '/img/otz/pudorys/tecko/variant-1.svg',
    },
    {
        value: 'T_SHAPED_1_TO_2',
        title: '"Téčko č.2"',
        img: '/img/otz/pudorys/tecko/variant-2.svg',
    },
    {
        value: 'T_SHAPED_1_TO_3',
        title: '"Téčko č.3"',
        img: '/img/otz/pudorys/tecko/variant-3.svg',
    },
];

export const houseGlazingOptions: DataEnumerations = [
    {
        value: 'LOW',
        title: 'Spíš malé',
        description: 'Málo oken nebo menší okna. Nemá žádné zasklené části (lodžie, balkón, terasa)',
        img: '/img/otz/proskleni/male.png',
    },
    {
        value: 'USUAL',
        title: 'Běžné',
        description: 'Standardní okna. Nemá žádné zasklené části (lodžie, balkón, terasa)',
        img: '/img/otz/proskleni/bezne.png',
    },
    {
        value: 'HIGH',
        title: 'Vyšší',
        description: 'Více oken nebo větší okna. Případně má zasklené části (lodžie, balkón, terasa)',
        img: '/img/otz/proskleni/vyssi.png',
    },
    {
        value: 'VERY_HIGH',
        title: 'Velmi vysoké',
        description: 'Prosklená stěna, velká okna a zasklené části (lodžie, balkón, terasa)',
        img: '/img/otz/proskleni/vysoke.png',
    },
];

export const wallInsulationOptions: DataEnumerations = [
    {
        value: 'NONE',
        title: 'Žádná izolace',
    },
    {
        value: 'WHITE_POLYSTYRENE',
        title: 'Bílý polystyren (EPS)',
        description: '(nebo Minerální vata)',
        img: '/img/otz/zatepleni-izolace/bily-polystyren.png',
    },
    {
        value: 'GREY_POLYSTYRENE',
        title: 'Šedý polystyren',
        img: '/img/otz/zatepleni-izolace/sedy-polystyren.png',
    },
    {
        value: 'XPS',
        title: 'XPS',
        img: '/img/otz/zatepleni-izolace/xps.png',
    },
];

// separate for further expansion
export const floorInsulationOptions: DataEnumerations = [
    {
        value: 'NONE',
        title: 'Žádná izolace',
    },
    {
        value: 'WHITE_POLYSTYRENE',
        title: 'Bílý polystyren (EPS)',
        description: '(nebo Minerální vata)',
        img: '/img/otz/zatepleni-izolace/bily-polystyren.png',
    },
    {
        value: 'GREY_POLYSTYRENE',
        title: 'Šedý polystyren',
        description: '(nebo XPS)',
        img: '/img/otz/zatepleni-izolace/sedy-polystyren.png',
    },
    {
        value: 'PIR_PUR',
        title: 'PIR / PUR',
        img: '/img/otz/zatepleni-izolace/pir-pur.png',
    },
];

export const roofInsulationOptions: DataEnumerations = [
    {
        value: 'NONE',
        title: 'Žádná izolace',
    },
    {
        value: 'WHITE_POLYSTYRENE',
        title: 'Bílý polystyren',
        description: '(EPS)',
        img: '/img/otz/zatepleni-izolace/bily-polystyren.png',
    },
    {
        value: 'MINERAL_FOAM',
        title: 'Minerální vata',
        img: '/img/otz/zatepleni-izolace/mineralni-vata.png',
    },
    {
        value: 'BLOWN_IN',
        title: 'Foukaná izolace',
        description: '(celulóza)',
        img: '/img/otz/zatepleni-izolace/foukana.png',
    },
];

export const floorCountOptions: DataEnumerations = [
    {
        value: '1',
        title: 'Bungalov',
        description: '(jen přízemí)',
        img: '/img/otz/pocet-pater/bungalov.png',
        imgTc: '/img/otz/pocet-pater/bungalov-tc.png',
    },
    {
        value: '2',
        title: 'Přízemí + 1 patro',
        description: '(celkem 2 obytná patra)',
        img: '/img/otz/pocet-pater/jedno-patro.png',
    },
    {
        value: '3',
        title: 'Přízemí + 2 patra',
        description: '(celkem 3 obytná patra)',
        img: '/img/otz/pocet-pater/dve-patra.png',
    },
];

export const bathroomCountOptions: DataEnumerations = [
    { value: '1', title: '1' },
    { value: '2', title: '2' },
    { value: '3', title: '3' },
];

export const otherBathroomCountOptions: DataEnumerations = [
    { value: 'other', title: 'jiný počet' },
    { value: '4', title: '4' },
    { value: '5', title: '5' },
    { value: '6', title: '6' },
    { value: '7', title: '7' },
];

export const roomDispositionsOptions: DataEnumerations = [
    { value: 'ONE_PLUS_ONE', title: '1 + 1' },
    { value: 'TWO_PLUS_ONE', title: '2 + 1' },
    { value: 'THREE_PLUS_ONE', title: '3 + 1' },
    { value: 'FOUR_PLUS_ONE', title: '4 + 1' },
    { value: 'FIVE_PLUS_ONE', title: '5 + 1' },
    { value: 'SIX_PLUS_ONE', title: '6 + 1' },
    { value: 'ONE_PLUS_KITCHEN', title: '1 + kk' },
    { value: 'TWO_PLUS_KITCHEN', title: '2 + kk' },
    { value: 'THREE_PLUS_KITCHEN', title: '3 + kk' },
    { value: 'FOUR_PLUS_KITCHEN', title: '4 + kk' },
    { value: 'FIVE_PLUS_KITCHEN', title: '5 + kk' },
    { value: 'SIX_PLUS_KITCHEN', title: '6 + kk' },
];

export const oldHeatSourceOptions: DataEnumerations = [
    { value: 'gas', title: 'Plyn' },
    { value: 'electric', title: 'Elektřina' },
    { value: 'pellets', title: 'Pelety' },
    { value: 'wood', title: 'Dřevo' },
    { value: 'coal', title: 'Uhlí' },
];

export const approvalDateOptions: DataEnumerations = [
    { value: 'two_years', title: 'před více než 36 měsíci' },
    { value: 'one_year', title: 'před méně než 36 měsíci' },
];

export const knowHeatLossOptions: DataEnumerations = [
    { value: 'YES', title: 'Ano' },
    { value: 'NO', title: 'Ne' },
];

export const photovoltaicsOptions: DataEnumerations = [
    { value: 'YES', title: 'Ano' },
    { value: 'NO', title: 'Ne' },
];

// const otherOptions = [
//     { value: 'other', title: 'Jiné' },
//     { value: '7+1', title: '7+1' },
//     { value: '8+1', title: '8+1' },
//     { value: '9+1', title: '9+1' },
//     { value: '10+1', title: '10+1' },
//     { value: '11+1', title: '11+1' },
//     { value: '12+1', title: '12+1' },
//     { value: '7+kk', title: '7+kk' },
//     { value: '8+kk', title: '8+kk' },
//     { value: '9+kk', title: '9+kk' },
//     { value: '10+kk', title: '10+kk' },
//     { value: '11+kk', title: '11+kk' },
//     { value: '12+kk', title: '12+kk' },
// ];
